<div>
    <div class="content">
        <list-view [liste]="listeImpBudg" *ngIf="listeImpBudg"></list-view>
    </div>
</div>